import React, { useEffect, useState } from 'react'
import { Link, useHistory } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { Input, Button, Dropdown } from 'sfy-react'
//import '../index.scss'

import { checkValues } from '../../../utils/regex'
import { postRequestAsync } from '../../../common/genericApi'

import { setLoader } from '../../../store/common'
import ViewIcon from '../../../assets/images/eye.svg'
import HideIcon from '../../../assets/images/hide.svg'
import InfoIcon from '../../../assets/images/info.svg'
import ApproverListModal from '../../../common/components/UIComponents/ApproverListModal/ApproverListModal'

const THEME_CONFIG = {
  ...window.appData,
}

const IMAGES = {
  SHOW_PASSSWORD: HideIcon,
  HIDE_PASSWORD: ViewIcon,
}

const COUNTRY_OPTIONS = [
  {
    key: 'in',
    value: 'India',
    uriKey: 'uriIN',
  },
  {
    key: 'us',
    value: 'US',
    uriKey: 'uriUS',
  },
  {
    key: 'eu',
    value: 'Europe',
    uriKey: 'uriEU',
  },
  {
    key: 'croma',
    value: 'Croma',
    uriKey: 'uriCroma',
  },
]

const LoginForm = ({ changeRoute, resetSuccessMsg }) => {
  const dispatch = useDispatch()
  const [showpassword, setShowPassword] = useState(false)
  const [formError, setFormError] = useState(false)
  const [error, setError] = useState({})
  const [isEmpty, setIsEmpty] = useState(true)
  const [isSubmitted, setIsSubmitted] = useState(false)
  const [selectedRegion, setSelectedCountry] = useState({})
  const [countryOptions, setCountryOptions] = useState(COUNTRY_OPTIONS)
  const [showModal, setShowModal] = useState(false)
  const history = useHistory()

  const [fields, setFields] = useState({
    password: '',
    username: '',
  })

  const {
    login: { username },
    login: { password },
  } = THEME_CONFIG.fieldsSet

  useEffect(() => {
    localStorage.clear()
    const filteredOptions = COUNTRY_OPTIONS.filter((eachCountry) => window[eachCountry['uriKey']])
    setCountryOptions(COUNTRY_OPTIONS.filter((eachCountry) => window[eachCountry['uriKey']]))
    if (!selectedRegion?.key) handleCountrySelection(filteredOptions[0])
    // eslint-disable-next-line
  }, [])

  const handleOnChange = (e) => {
    setFields({
      ...fields,
      [e.target.name]: e.target.value,
    })
  }

  useEffect(() => {
    let { isValid, isEmpty, error } = checkValues(fields)
    if (isSubmitted) {
      setError(error)
      setIsEmpty(isEmpty)
      isValid ? setFormError(null) : setFormError('There are items above that need your attention')
    } else {
      setIsEmpty(isEmpty)
    }
  }, [isSubmitted, fields])

  const setAccess = (appAccess = []) => {
    localStorage.setItem('access', JSON.stringify(appAccess))
  }

  const handleOnSubmit = async (e) => {
    e.preventDefault()
    setIsSubmitted(true)
    if (checkValues(fields).isValid) {
      try {
        dispatch(setLoader(true))
        let access = await postRequestAsync('/user/login', {
          loginID: fields.username,
          password: fields.password,
        })
        dispatch(setLoader(false))

        if (access.success) {
          localStorage.setItem('isLoggedIn', true)
          localStorage.setItem('username', fields.username)
          setAccess(access.data)
          changeRoute('/')
        }
      } catch (e) {
        console.log(e)
        setFormError(e.msg)
        dispatch(setLoader(false))
      }
    } else {
      setFormError('There are items above that need your attention')
    }
  }

  const handleCountrySelection = (selectedOption) => {
    // const currentOptions = getSelectedKeys(COUNTRY_OPTIONS, selectedOption?.value, 'value')
    localStorage.setItem('selectedRegion', selectedOption.key)
    setSelectedCountry(selectedOption)
    // changeRoute('/login')
  }

  return (
    <>
      <div className='label mb5'>Your Region</div>
      <Dropdown
        classObject={{ container: `small-dropdown country-dropdown` }}
        options={countryOptions}
        value={selectedRegion?.value}
        handleOnChange={(value) => {
          handleCountrySelection(value)
        }}
        filterBy='value'
        searchText='Choose Region'
        isDisabled={false}
      />
      <form onSubmit={handleOnSubmit}>
        <div className='label mb5'>Username</div>
        <Input
          placeholder={username?.placeholder || 'Enter your Username'}
          message={{ value: error.username }}
          className={{ message: error.username ? 'error' : '' }}
          value={fields.username}
          handleOnChange={handleOnChange}
          name={username?.name || 'username'}
          otherProps={{ autoFocus: true }}
        />
        <div className='label mt20 mb5'>Password</div>
        <Input
          placeholder={password?.placeholder || 'Enter your password'}
          message={{ value: error.password }}
          className={{
            inputContainer: 'password-field',
            message: error.password ? 'error' : '',
          }}
          value={fields.password}
          handleOnChange={handleOnChange}
          otherProps={{ type: showpassword ? 'text' : 'password' }}
          name={password?.name || 'password'}
        >
          <span className='password-control' onClick={() => setShowPassword(!showpassword)}>
            <img src={showpassword ? IMAGES.HIDE_PASSWORD : IMAGES.SHOW_PASSSWORD} alt='password' />
          </span>
        </Input>

        <div className='d-flex forgot-password-link'>
          <Link to='/forgot-password' title='Forgot Password' className='mt30'>
            Forgot Password ?
          </Link>
        </div>

        {isSubmitted && formError && (
          <div className='d-flex'>
            <div className='error mt10'>{formError}</div>
          </div>
        )}
        {resetSuccessMsg && (
          <div className='d-flex'>
            <div className='success color-theme mt10'>{resetSuccessMsg}</div>
          </div>
        )}

        <div className='d-flex space-between mt32'>
          {/* commented out to match new design */}
          {/* <Button
            type='button'
            classes='button-ghost mr10'
            title='Sign Up'
            onClick={() => {
              history.push('/sign-up')
            }}
          >
            Sign Up
          </Button> */}
          <Button type='submit' text='Login' classes='button-primary botton-submit ' isDisabled={isEmpty} />
        </div>

        {process.env.REACT_APP_ENVIRONMENT !== 'xcentral' && (
          <div className='sign-up-link'>
            <div
              className='sign-up-link-text f14 text-center mt15'
              onClick={() => {
                history.push('/sign-up')
              }}
            >
              New user? Sign up
            </div>
            <span onClick={() => setShowModal(true)} className='ml5 mt20'>
              <img src={InfoIcon} alt="Central Apps Approver's Info" title="Central Apps Approver's Info" />
            </span>
          </div>
        )}
      </form>
      <ApproverListModal showModal={showModal} setShowModal={setShowModal} />
    </>
  )
}

export default LoginForm
